import { initGetDRMToken } from "../drm_actions";

export const ASSET_DETAILS_ACTIONS = {
  SET_CURRENT_ASSET: "SET_CURRENT_ASSET",
};

export const setCurrentAsset = (params: any) => {
  return async (dispatch: Function) => {
    let data = {
      public: params.public,
      category: params.category,
      asset: params.asset,
    };
    dispatch(initGetDRMToken());
    dispatch({
      type: ASSET_DETAILS_ACTIONS.SET_CURRENT_ASSET,
      data,
    });
  };
};
